export default "__VITE_ASSET__COZwV6Cz__"